import { SourceEntity } from 'types/SourceEntity'
import ApiBase from './Api'

type IssueFields = {
    statusStage: number
    statusComplete: boolean
}

type NewSource = {
    issueId?: string
    convertibleId?: string
    sourceUrl: string
    sourceType: string
    title: string
    publishedDate: Date
    releaseDatetime: Date
}

const SOURCE_API_PATHS = {
    SOURCES: '/sources',
    SOURCES_ADMIN: '/admin/sources',
}

class SourceApi extends ApiBase {
    async findBySourceUrl(sourceUrl: string) {
        const response: SourceEntity = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: {
                sourceUrl: encodeURI(sourceUrl),
            },
        })
        return response
    }
    async findByIssueId(issueId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { issueId },
        })
        return response
    }
    async findByWarrantId(warrantId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { warrantId },
        })
        return response
    }
    async findByConvertibleId(convertibleId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: { convertibleId },
        })
        return response
    }
    async create(newSource: NewSource, issueFields?: IssueFields) {
        const response = await this._postRequest(SOURCE_API_PATHS.SOURCES_ADMIN, {
            ...newSource,
            issueFields,
        })
        return response
    }
}

export default SourceApi
